import slugify from "slugify";

export default (value: string) => {
  if (!value) {
    return "";
  }
  return slugify(value).toLowerCase();
};
